import * as Types from '../../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DeleteAllSearchHistoryMutationVariables = Types.Exact<{ [key: string]: never }>;

export type DeleteAllSearchHistoryMutation = { deleteAllSearchHistory: boolean };

export const DeleteAllSearchHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAllSearchHistory' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'deleteAllSearchHistory' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAllSearchHistoryMutation,
  DeleteAllSearchHistoryMutationVariables
>;
